import * as Sentry from '@sentry/nextjs';
import { Integrations } from '@sentry/nextjs';
import { Offline as OfflineIntegration } from '@sentry/integrations';

import {
  MAX_BREADCRUMBS,
  TRACES_SAMPLE_RATE,
  NORMALIZE_DEPTH,
} from 'constants/constants';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
    tracesSampleRate: TRACES_SAMPLE_RATE,
    integrations: [
      new Integrations.BrowserTracing(),
      new OfflineIntegration(),
    ],
    maxBreadcrumbs: MAX_BREADCRUMBS,
    normalizeDepth: NORMALIZE_DEPTH,
  });
}
